/**
 * Мок каталога триал-функций: реалистичные права кабинета по группам.
 * Мутация пишет флаги в строки — после инвалидации UI ведёт себя как BE.
 */

import type {TrialFeature, UpdateTrialFeaturesInput} from './types';

type Seed = [key: string, groupKey: string, description: string, inTrial: boolean];

const SEEDS: Seed[] = [
  ['schedule.view_all', 'schedule', 'Видеть расписание всех врачей', true],
  ['schedule.manage', 'schedule', 'Создавать и переносить приёмы', true],
  ['schedule.working_hours', 'schedule', 'Настраивать график работы', true],
  ['patients.view', 'patients', 'Смотреть базу пациентов', true],
  ['patients.manage', 'patients', 'Создавать и править пациентов', true],
  ['patients.teeth', 'patients', 'Одонтограмма и история зуба', true],
  ['cash.view', 'cash', 'Смотреть кассу и долги', true],
  ['cash.accept', 'cash', 'Принимать оплаты', false],
  ['cash.refund', 'cash', 'Проводить возвраты', false],
  ['reports.view_all', 'reports', 'Отчёты клиники (вся выручка)', false],
  ['reports.doctors', 'reports', 'Отчёт по врачам', false],
  ['staff.manage', 'staff', 'Управлять сотрудниками', true],
  ['staff.roles', 'staff', 'Настраивать роли и права', false],
  ['services.manage', 'services', 'Вести прайс услуг', true],
];

export const MOCK_TRIAL_FEATURES: TrialFeature[] = SEEDS.map(
  ([key, groupKey, description, inTrial], i) => ({
    id: `tf-${i + 1}`,
    key,
    groupKey,
    description,
    inTrial,
  }),
);

/** Мок-PATCH: применяет флаги, возвращает свежие копии (как BE). */
export const applyTrialUpdateMock = (input: UpdateTrialFeaturesInput): TrialFeature[] => {
  for (const {key, inTrial} of input.items) {
    const row = MOCK_TRIAL_FEATURES.find((f) => f.key === key);
    if (row !== undefined) row.inTrial = inTrial;
  }
  return MOCK_TRIAL_FEATURES.map((f) => ({...f}));
};
